module.exports = __webpack_public_path__ + "static/img/12.b0cd1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/12.png
// module id = A7bo
// module chunks = 1